import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/headerExpanded.js';
import { filterUnusedPages } from 'utils/bolt/header';
import { sortObjectByOrder, accessNested } from 'utils/utils';
import s from 'components/bolt/header/headerExpanded.sss';

export default class HeaderExpanded extends BaseComp.default {
	updateLinks(props = this.props) {
		this.navItems = sortObjectByOrder(accessNested(props, 'appData.header.powsterHeader.nav'));
		this.filteredNavItems = filterUnusedPages(props, this.navItems);
		this.standardLinks = this.navItems.filter(item => item && item.linkType === 'primary');
		this.featuredLinks = this.navItems.filter(item => item && item.linkType === 'secondary');
	}

	renderLink(element, isFeatured) {
		const baseJSX = super.renderLink(element, isFeatured);
		const activePage = this.props.activePage || 'boltHome';
		const [pageId, hash] = element.path?.split('#') || [];
		let active;
		if (typeof window !== 'undefined') {
			if (activePage === pageId) {
				active = true;
				if (window?.location?.href.includes('#')) {
					active = false;
				}
				if (hash) {
					active = false;
				}
			}
			if (hash) {
				if (window?.location?.href.split('#')[1] === hash) {
					active = true;
				}
			}
		}
		if (active) {
			baseJSX.attributes.class += ' ' + s.active;
		} else {
			baseJSX.attributes.class = baseJSX.attributes.class.replace(s.active, '');
		}
		return baseJSX;
		
	}
}
